import React from 'react';
import PropTypes from 'prop-types';
import { ErrorHandler } from '@playbookux/playbook-web-core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import { GET_CONSENT_FORMS_BY_COMPANY, GET_IS_COMPANY_CONSENT_FORM_REQUIRED } from '../../../../../core/graphql/consent-forms';
import ConsentFormManagementComponentBody from './body';
import ConsentFormManagementComponentHeader from './header';
import {
  Container,
  Loader,
  ContainerLoading,
} from '../../styles';

const ConsertFormManagementComponent = ({ companyId }) => {
  const {
    data: consentFormsResponse,
    error: consentFormsResponseError,
    loading: isConsentFormsResponseLoading,
    refetch: refetchConsentForms,
  } = useQuery(GET_CONSENT_FORMS_BY_COMPANY, {
    variables: {
      companyId,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const {
    data: isConsentFormsRequiredResponse = {},
    error: consentFormRequiredResponseError,
    loading: isConsentFormRequiredResponseLoading,
    refetch: refetchConsentFormRequired,
  } = useQuery(GET_IS_COMPANY_CONSENT_FORM_REQUIRED, {
    variables: {
      companyId,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  if (consentFormsResponseError || consentFormRequiredResponseError) {
    return (
      <Container center>
        <ErrorHandler
          error={consentFormsResponseError || consentFormRequiredResponseError}
          defaultMessage="Error while retrieving consent forms."
        />
      </Container>
    );
  }
  return (
    <>
      {
        (
          isConsentFormsResponseLoading
          || isConsentFormRequiredResponseLoading
        ) && (
          <ContainerLoading>
            <Loader active data-loader="consent-form-loader" />
          </ContainerLoading>
        )
      }
      <ConsentFormManagementComponentHeader
        isConsentFormRequired={isConsentFormsRequiredResponse?.company?.consentFormRequired}
        companyId={companyId}
        refetchConsentFormRequired={refetchConsentFormRequired}
        canSetCompanyConsentFormRequired={consentFormsResponse?.consentForms?.length > 0}
      />
      <ConsentFormManagementComponentBody
        consentForms={consentFormsResponse?.consentForms || []}
        refetchConsentForms={refetchConsentForms}
        refetchConsentFormsRequired={refetchConsentFormRequired}
      />
    </>
  );
};

ConsertFormManagementComponent.propTypes = {
  companyId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  companyId: authentication.company?.id,
});

const enhance = compose(
  connect(mapStateToProps, null),
);

export default enhance(ConsertFormManagementComponent);
